import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';

interface Props {
  content: string;
}

const MessageInfo: React.FC<Props> = ({ content }) => (
  <div className="uzy-tool-card" style={{ borderColor: '#91caff' }}>
    <div className="uzy-tool-card-header" style={{ background: '#e6f4ff', borderBottomColor: '#91caff', color: '#1677ff' }}>
      <InfoCircleOutlined style={{ marginRight: 6 }} />提示
    </div>
    <div className="uzy-tool-card-body">{content}</div>
  </div>
);

export default MessageInfo;
